import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-save",
  "use": "rt-base-save-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-base-save\">\n<g>\n\t<path d=\"M880-156H208c-55.1,0-100,44.9-100,100v672c0,55.1,44.9,100,100,100h672c55.1,0,100-44.9,100-100V-56\n\t\tC980-111.1,935.1-156,880-156z M376-84h336v191c0,20.1-14.7,37-32,37H408c-17.3,0-32-17-32-37V-84z M908,616c0,15.4-12.6,28-28,28\n\t\tH208c-15.4,0-28-12.6-28-28V-56c0-15.4,12.6-28,28-28h104v191c0,55.7,43.1,101,96,101h272c52.9,0,96-45.3,96-101V-84h104\n\t\tc15.4,0,28,12.6,28,28V616z\" />\n\t<path d=\"M736,408H352c-17.6,0-32,14.4-32,32s14.4,32,32,32h384c17.6,0,32-14.4,32-32S753.6,408,736,408z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/save.svg
// module id = 1283
// module chunks = 124